import { format, roundToNearestMinutes } from 'date-fns'
import { type FunctionComponent } from 'react'
import { TimeFormats } from '@/common/datepicker/utilities/formats'
import { type InboxThreadEventEventableNoteType } from '@/state/entities/inbox/inbox.types'
import { ThreadPopover } from './common'
import { MessageRow, emailBodyClasses } from './message-row'

const ThreadNoteBox: FunctionComponent<{
  event: InboxThreadEventEventableNoteType
}> = ({ event }) => {
  return (
    <MessageRow
      direction="note"
      name={event.user_name}
      email={event.user_email}
      time={format(
        roundToNearestMinutes(event.created_at, { nearestTo: 10 }),
        TimeFormats.FourHourApple
      )}
      info={<ThreadPopover event={event} />}
    >
      <div
        className={emailBodyClasses}
        dangerouslySetInnerHTML={{ __html: event.description }}
      />
    </MessageRow>
  )
}

export default ThreadNoteBox
